import {
  Directive,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { BOProduct } from '@boels/models';
import { removeHtmlTagsFromString } from '../../utils';
import { getPricingDetails } from '../../utils/get-unit-price-for-seo.utils';

@Directive({
  standalone: true,
  selector: '[boelsDataDm]',
})
export class DataDmAttributeDirective implements OnInit {
  #elementRef = inject(ElementRef);
  #renderer = inject(Renderer2);

  product = input.required<BOProduct>();
  productIndex = input.required<number>();
  componentName = input.required<string>();
  variantName = input<string>(); //If the product variant is passed.
  quantity = input<number>();

  ngOnInit() {
    this.#renderer.setAttribute(
      this.#elementRef.nativeElement,
      'data-dm',
      this.setDataAttribute(),
    );
  }

  setDataAttribute(): string {
    const { price, currency, pricing_unit } = getPricingDetails(
      this.product().unitPrices || [],
    );
    const dataAttribute = {
      data_type: 'Product',
      item_name: removeHtmlTagsFromString(
        this.variantName() || this.product().name || '',
      ),
      item_id: this.product().code,
      item_category: this.getItemCategories(2),
      item_category2: this.getItemCategories(1),
      item_list_name: this.componentName,
      index: this.productIndex() + 1,
      quantity: this.quantity() || 1,
      is_accessory: this.product().isAccessory || false,
      price: price,
      currency: currency,
      pricing_unit: pricing_unit,
    };

    return JSON.stringify(dataAttribute);
  }

  getItemCategories(level: number): string {
    const nativeBreadcrumbs = this.product().alternates?.[0]?.nativeBreadcrumbs;
    return (
      nativeBreadcrumbs && nativeBreadcrumbs[nativeBreadcrumbs.length - level]
    );
  }
}
